import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  // Check for simple admin login in localStorage
  const simpleAdminUser = localStorage.getItem('adminUser');
  let adminUser = null;
  if (simpleAdminUser) {
    try {
      adminUser = JSON.parse(simpleAdminUser);
    } catch (e) {
      console.error('Error parsing admin user from localStorage:', e);
    }
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  // Use simple admin user if available, otherwise use AuthContext user
  const currentUser = adminUser || user;

  if (!currentUser) {
    return <Navigate to="/admin/login" replace />;
  }

  if (adminOnly && currentUser.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
